import { render, staticRenderFns } from "./Masterlist.vue?vue&type=template&id=2dbea626&scoped=true&"
import script from "./Masterlist.vue?vue&type=script&lang=js&"
export * from "./Masterlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbea626",
  null
  
)

export default component.exports